module.exports = __webpack_public_path__ + "static/media/financiaciones.2f9706e9.svg";